import { DollarApollo } from "vue-apollo/types/vue-apollo";
import { FetchResult } from "apollo-link";
import Mutation from "./mutation.gql";

export interface Result {
  test: string;
}

export const createAppUserTask = async <V>(
  apollo: DollarApollo<V>,
  appUserId: string,
  buildingId: string,
  roomIds: string[]
): Promise<FetchResult<Result>> => {
  const result = apollo.mutate({
    mutation: Mutation,
    variables: { appUserId, buildingId, roomIds }
  });
  return result;
};
